export const FETCH_NAV_HEADER_PENDING = "FETCH_NAV_HEADER_PENDING";
export const FETCH_NAV_HEADER_REJECTED = "FETCH_NAV_HEADER_REJECTED";
export const FETCH_NAV_HEADER_FULFILLED = "FETCH_NAV_HEADER_FULFILLED";


// WEBPACK FOOTER //
// ./src/constants/navHeader.js